module.exports = __webpack_public_path__ + "img/[裂开].f8c825be.svg";